import { dashboardv20240509Client } from '@sequencehq/api/dashboard/v20240509'
import { SequenceMenu } from '@sequencehq/core-components'
import { downloadBlob, filenameFromResponse } from '@sequencehq/utils'
import { useNotifications } from '@sequencehq/core-components'
import { FC, useCallback } from 'react'

interface DownloadQuotePdfMenuItemProps {
  quoteId: string
  quoteNumber: string
  isPublished: boolean
  onSuccess?: () => void
}

export const DownloadQuotePdfMenuItem: FC<DownloadQuotePdfMenuItemProps> = ({
  quoteId,
  quoteNumber,
  isPublished,
  onSuccess
}) => {
  const { displayPromiseNotification } = useNotifications()

  const handleDownloadPdf = useCallback(async () => {
    const downloadOperation = async () => {
      const response = await dashboardv20240509Client.downloadQuotePdf({
        id: quoteId
      })

      if (!response || !response.data) {
        throw new Error('Failed to download PDF: No data in response')
      }

      downloadBlob(filenameFromResponse(response.res, `${quoteNumber}.pdf`))(
        response.data
      )
      onSuccess?.()
      return response.data
    }

    await displayPromiseNotification(downloadOperation(), {
      loading: 'Downloading PDF...',
      success: 'PDF downloaded successfully',
      error: 'Failed to download PDF'
    })
  }, [quoteId, quoteNumber, displayPromiseNotification, onSuccess])

  if (!isPublished) {
    return null
  }

  return (
    <SequenceMenu.Item
      uuid="download-pdf"
      label="Download PDF"
      data-testid={`quotes.${quoteId}.download-pdf`}
      onClick={handleDownloadPdf}
    />
  )
}
